import { render, staticRenderFns } from "./P0115.vue?vue&type=template&id=79c8ab22&"
import script from "./P0115.vue?vue&type=script&lang=ts&"
export * from "./P0115.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports